import { BRAND_NAME } from '@repo/ui/components/marchio'
import { type AppLanguageCode, type TKey, translateApp } from '@/lib/i18n'

/** The document title of an admin page: its name, then the brand, as the public pages write it. */
export function pageTitle(language: AppLanguageCode, key: TKey) {
	return `${translateApp(language, key)} | ${BRAND_NAME}`
}
